query Prompts {
  promptsModule
  travelerStoriesModule {
    blogUrl
    order
    tags
    thumbnail
    title
    url
    videoDuration
  }
  inspirationsModule {
    city
    description
    image
    order
    url
  }
}
